<template>
  <p
    v-if="!fileList.length"
    class="empty-data"
  >
    Nothing in the list...
  </p>
</template>

<script>
export default {
  name: 'FileMediaItemListEmptyState',
  props: {
    fileList: {
      type: Array,
      required: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Submission/steps/FilesMedia/FileMediaItemListEmptyState.vue